(function () {
  var storageKey = 'xtremesystem_campaign_attribution';
  var fields = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];

  function readCampaign() {
    var params = new URLSearchParams(window.location.search);
    var values = {};

    fields.forEach(function (field) {
      var value = params.get(field);
      if (value) values[field] = value.substring(0, 120);
    });

    if (params.get('gclid')) values.utm_source = values.utm_source || 'google-ads';
    if (Object.keys(values).length) {
      try {
        sessionStorage.setItem(storageKey, JSON.stringify(values));
      } catch (error) {
        // Attribution is helpful but should never block a repair enquiry.
      }
      return values;
    }

    try {
      return JSON.parse(sessionStorage.getItem(storageKey) || '{}');
    } catch (error) {
      return {};
    }
  }

  function campaignLabel(values) {
    var parts = fields.map(function (field) {
      return values[field] ? field.replace('utm_', '') + '=' + values[field] : '';
    }).filter(Boolean);

    if (parts.length) return parts.join(' | ');
    if (document.referrer) {
      try {
        return 'referrer=' + new URL(document.referrer).hostname;
      } catch (error) {
        return 'referrer=unknown';
      }
    }
    return 'direct / untagged';
  }

  document.addEventListener('DOMContentLoaded', function () {
    var label = campaignLabel(readCampaign());
    document.querySelectorAll('[data-campaign-field]').forEach(function (field) {
      field.value = label;
    });
  });
})();
